import {Component, computed, effect, input, model} from '@angular/core';
import {ButtonModule} from 'primeng/button';
import {DialogModule} from 'primeng/dialog';
import {InputTextModule} from 'primeng/inputtext';
import {MultiSelectModule} from 'primeng/multiselect';
import {ReactiveFormsModule, Validators} from '@angular/forms';
import {TranslocoDirective, TranslocoPipe} from '@jsverse/transloco';
import {DividerModule} from 'primeng/divider';
import {TreeSelectModule} from 'primeng/treeselect';
import {ProviderRoleResponse} from '@frontend/shared-api';
import {MessageModule} from 'primeng/message';
import {FormFieldComponent} from '../../../../shared/components/inputs/form-field/form-field.component';
import {SelectTranslationOption} from '../../../../shared/components/inputs/select/select.types';
import {
  AbstractFormDirective,
  FormControlsConfig,
} from '../../../customer/project-sequence/chapter/chapter-8-rfq/step-8-1-proposal-parameter/components/abstract-form-directive';
import {FormValidationService} from '../../../../shared/services/form-validation.service';

export interface ProviderUserFormData {
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  role?: ProviderRoleResponse;
}

@Component({
  selector: 'app-add-edit-provider-user-dialog',
  imports: [
    ButtonModule,
    DialogModule,
    InputTextModule,
    MultiSelectModule,
    TranslocoDirective,
    TranslocoPipe,
    DividerModule,
    TreeSelectModule,
    MessageModule,
    ReactiveFormsModule,
    FormFieldComponent,
  ],
  templateUrl: './add-edit-provider-user-dialog.component.html',
})
export class AddEditProviderUserDialogComponent extends AbstractFormDirective<ProviderUserFormData> {
  private static readonly FORM_CONTROLS: FormControlsConfig<ProviderUserFormData> = {
    firstName: [null, {validators: [Validators.required]}],
    lastName: [null, {validators: [Validators.required]}],
    email: [null, {validators: [Validators.required, Validators.email]}],
    phoneNumber: [null, {validators: [Validators.required, FormValidationService.phoneValidator]}],
    role: [null, {validators: [Validators.required]}],
  };

  private static readonly IDENTITY_PROVIDER_FIELDS: (keyof ProviderUserFormData)[] = [
    'firstName',
    'lastName',
    'email',
    'phoneNumber',
  ];

  readonly roles = input.required<ProviderRoleResponse[]>();
  readonly editMode = input.required<boolean>();
  readonly emailEditingDisabled = input<boolean>(false);
  readonly scimManaged = input<boolean>(false);
  readonly emailFieldDisabled = computed(() => this.emailEditingDisabled() || this.scimManaged());
  visible = model<boolean>(false);

  readonly roleOptions = computed(() =>
    this.roles()?.map(
      (role) =>
        ({
          id: role.role,
          role: role.role,
          translations: role.translations,
        }) as unknown as SelectTranslationOption,
    ),
  );

  close(): void {
    this.visible.set(false);
  }

  constructor() {
    super(AddEditProviderUserDialogComponent.FORM_CONTROLS);
    effect(() => {
      const locked = this.scimManaged();
      AddEditProviderUserDialogComponent.IDENTITY_PROVIDER_FIELDS.forEach((field) => {
        const control = this.theForm.get(field);
        if (locked) {
          control?.disable({emitEvent: false});
        } else {
          control?.enable({emitEvent: false});
        }
      });
    });
  }
}
